import { useMutation } from '@apollo/client';
import { gql } from '@apollo/client/core';

const CREATE_HOLIDAY = gql`
  mutation CreateHoliday(
    $title: String!
    $startDate: ISO8601Date!
    $endDate: ISO8601Date!
  ) {
    createHoliday(
      input: { title: $title, startDate: $startDate, endDate: $endDate }
    ) {
      uid
    }
  }
`;

export const useCreateHoliday = () => {
  const [createHolidayMutation] = useMutation(CREATE_HOLIDAY); // Destructure error from useMutation

  const handleCreateHoliday = async ({ title, startDate, endDate }) => {
    try {
      const response = await createHolidayMutation({
        variables: {
          title,
          startDate,
          endDate,
        },
      });

      return response;
    } catch (err) {
      console.log('Error creating holiday:', err);
      // Handle the error appropriately (e.g., display a user-friendly message)

      // Check for GraphQL errors
      if (err.graphQLErrors && err.graphQLErrors.length > 0) {
        // Handle GraphQL errors
        return err.graphQLErrors[0]?.message;
      }

      // Check for network errors
      if (err.networkError) {
        // Handle network errors
        console.error('Network error:', err.networkError);
        // You can choose to handle network errors differently
        // For instance, you can throw a custom error or return a specific response
      }

      return null; // Or throw a custom error for further handling
    }
  };

  return handleCreateHoliday;
};
